/**
 * O link recém-gerado da apresentação: endereço, copiar,
 * mandar no WhatsApp e abrir.
 */
import { useNotify } from 'ra-core';
import { Copy, ExternalLink, MessageCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { DIAS_DO_LINK } from './estudoLink';

export const LinkDoEstudo = ({ url }: { url: string }) => {
  const notify = useNotify();
  const copiar = async () => {
    try {
      await navigator.clipboard.writeText(url);
      notify('Link copiado.', { type: 'info' });
    } catch {
      notify('Não foi possível copiar. Selecione o link e copie.', { type: 'warning' });
    }
  };

  return (
    <div className="space-y-2 rounded-md border border-[#C4AD8E] bg-[#F3EDE3]/60 px-3 py-3 text-sm dark:bg-muted">
      <Label htmlFor="pqc-link">Link da apresentação · válido por {DIAS_DO_LINK} dias</Label>
      <Input id="pqc-link" readOnly value={url} className="h-8 font-mono text-xs" onFocus={(e) => e.currentTarget.select()} />
      <div className="flex flex-wrap gap-2">
        <Button type="button" size="sm" variant="outline" onClick={copiar}>
          <Copy className="mr-1 h-4 w-4" /> Copiar
        </Button>
        <Button type="button" size="sm" variant="outline" asChild>
          <a href={`https://wa.me/?text=${encodeURIComponent(`Preparei uma apresentação do seu consórcio: ${url}`)}`} target="_blank" rel="noreferrer">
            <MessageCircle className="mr-1 h-4 w-4" /> Enviar no WhatsApp
          </a>
        </Button>
        <Button type="button" size="sm" variant="ghost" asChild>
          <a href={url} target="_blank" rel="noreferrer">
            <ExternalLink className="mr-1 h-4 w-4" /> Abrir
          </a>
        </Button>
      </div>
    </div>
  );
};
